import classNames from 'classnames';
import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { UserRun } from '../../../../Models/User/UserRun';
import { WidgetDisplayMode } from '../../../../Models/Widget/WidgetDisplayMode';
import WidgetActions from '../../../../Modules/Redux/Pages/Widget/WidgetActions';
import WidgetSelectors from '../../../../Modules/Redux/Pages/Widget/WidgetSelectors';
import { isBetween } from '../../../../Utils/Maths';
import { Optional } from '../../../../Utils/Types';
import { Switch } from '../../Components/Switch/Switch';
import { SwitchCase } from '../../Components/SwitchCase/SwitchCase';
import { WidgetBackground } from './Components/Background/WidgetBackground';
import { WidgetBackgroundGradient } from './Components/BackgroundGradient/WidgetBackgroundGradient';
import { WidgetMoonCounter } from './Components/MoonCounter/WidgetMoonCounter';
import { WidgetNextMoon } from './Components/NextMoon/WidgetNextMoon';

export const WidgetPage: FunctionComponent = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const dispatch = useDispatch();
  const displayMode: WidgetDisplayMode = useSelector(WidgetSelectors.displayMode);
  const run: Optional<UserRun> = useSelector(WidgetSelectors.run);
  const scale: number = useSelector(WidgetSelectors.scale);

  useEffect(() => {
    if (sessionId) {
      dispatch(WidgetActions.connectWidget(sessionId));
    }
    return (): void => {
      dispatch(WidgetActions.disconnectWidget());
    };
  }, [sessionId]);

  return (
    <div className="relative">
      <WidgetBackground />
      <div className="absolute top-0 bottom-0 left-0 right-0">
        <WidgetBackgroundGradient />
      </div>
      {run ? (
        <div
          className={classNames(
            'absolute left-0 right-0 bottom-0',
            isBetween(scale, 0, 50) ? 'px-4 pb-4 space-y-8' : 'px-8 pb-8 space-y-16'
          )}
        >
          <Switch value={displayMode}>
            <SwitchCase value={WidgetDisplayMode.all}>
              <WidgetNextMoon />
              <WidgetMoonCounter />
            </SwitchCase>

            <SwitchCase value={WidgetDisplayMode.nextMoonOnly}>
              <WidgetNextMoon />
            </SwitchCase>

            <SwitchCase value={WidgetDisplayMode.moonCountOnly}>
              <WidgetMoonCounter />
            </SwitchCase>
          </Switch>
        </div>
      ) : undefined}
    </div>
  );
};
